import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import { Button } from './Button';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    //Button won't show up after resize and refreshing while in the smaller sized screen.
    useEffect(() => {
        showButton();
    }, [])

    window.addEventListener('resize', showButton);

    return (
        <>
          <nav className="navbar">
              <div className="navbar-container">
                  <Link to="/" className="navbar-logo" onClick= {closeMobileMenu}>
                      Trash Predictor <i class="fas fa-trash"></i>
                  </Link>
                  <div className='menu-icon' onClick={handleClick}>
                      <i className={click ? 'fas fa-times' : 'fas fa-bars'}/>
                  </div>
                  <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                      <li className='nav-item'>
                          <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                              Home
                          </Link>
                      </li>
                      <li className='nav-item'>
                          <Link to='/team5' className='nav-links' onClick={closeMobileMenu}>
                              Team
                          </Link>
                      </li>
                      <li className='nav-item'>
                      <a href="https://xd.adobe.com/view/84d90827-5f4a-48d5-a3ff-0d90e1d89474-d18a/" className='nav-links' onClick={closeMobileMenu}>Prototype</a>
                          {/* <Link to='/prototype' className='nav-links' onClick={closeMobileMenu}>
                              Prototype
                          </Link> */}
                      </li>
                      <li className='nav-item'>
                          <Link to='/sign-up' className='nav-links-mobile' onClick={closeMobileMenu}>
                              Sign Up
                          </Link>
                      </li>
                  </ul>
                  {button && <Button buttonStyle='btn--outline'>SIGN UP</Button>}
              </div>
          </nav>
        </>
    );
}

export default Navbar
